import React, { useState, useEffect } from 'react';
import '../../stylesheets/UserManagement.css';
import { useNavigate } from 'react-router-dom';
import Toolbar from '../Toolbar';
import Sidebar from '../Sidebar';
import AddUser from "./AddUser";
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import { UserManagementAPI } from "../../axios";

const ManageRoles = () => {
  const navigate = useNavigate();
  const [addNewUser, setAddNewUser] = useState(false);
  const [roleNames, setRoleNames] = useState([]);
  const [roles, setRoles] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const rolesPerPage = 5;
  const pagesToShow = 5;

  useEffect(() => {
    UserManagementAPI.fetch_roles()
      .then((res) => {
        if (res.code === 200) {
          setRoles(res.data.roles);
          const roleNames = res.data.roles.map(role => role.name);
          setRoleNames(roleNames);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  const indexOfLastRole = currentPage * rolesPerPage;
  const indexOfFirstRole = indexOfLastRole - rolesPerPage;
  const currentRoles = roles.slice(indexOfFirstRole, indexOfLastRole);

  // Total number of pages
  const totalPages = Math.ceil(roles.length / rolesPerPage);

  // Calculate the range of page buttons to display
  const startPage = Math.max(1, currentPage - Math.floor(pagesToShow / 2));
  const endPage = Math.min(totalPages, startPage + pagesToShow - 1);

  // Change page
  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  // Move to previous set of pages
  const handlePrevSet = () => {
    setCurrentPage((prev) => Math.max(1, prev - pagesToShow));
  };

  // Move to next set of pages
  const handleNextSet = () => {
    setCurrentPage((prev) => Math.min(totalPages, prev + pagesToShow));
  };

  const closeDialog = () => {
    setAddNewUser(false);
  };

  const openDialog = () => {
    setAddNewUser(true);
  };

  const onNewRole = () => {
    navigate('/create-role');
  };

  return (
    <div className="main-container">
      <Toolbar />
      <Sidebar />
      <div className="content-container">
        <div className="main-content">
          <div className="management-header">
            <h3>User Management</h3>
            <div className="buttons">
              <button className="add-user" onClick={onNewRole}>Create New Role</button>
              <button className="add-user" onClick={openDialog}>Add New User</button>
            </div>
          </div>
          <div className="manage-headings">
            <span
              style={{
                textDecoration:'none',
                textDecorationColor: 'transparent',
                textDecorationThickness: 'auto',
                textUnderlineOffset: '0px',
                fontWeight: '400',
                cursor: 'pointer',
              }}
              onClick={() => { 
                navigate('/manage-users');
              }}
            >
              Manage Users
            </span>
            <span
              style={{
                textDecoration: 'underline',
                textDecorationColor: '#8F9BC5',
                textDecorationThickness: '1.5px',
                textUnderlineOffset: '4px',
                fontWeight: '500',
                cursor: 'pointer',
              }}
              onClick={() => { 
                navigate('/manage-roles');
              }}
            >
              Manage Roles
            </span>
          </div>
          <div style={{ marginTop: '30px' }}>
            <div className='manage-roles'>
              <span>Role</span>
              <span>Description</span>
              <span>Permissions</span>
              <span>Countries</span>
            </div>
            {currentRoles.map(role => (
              <div className='manage-roles' key={role.id}>
                <span>{role.name}</span>
                <span>{role.description}</span>
                <span>{role.permissions.join(', ')}</span>
                <span>{role.countries.join(', ')}</span>
              </div>
            ))}
          </div>

          <div className='pagination'>
            {startPage > 1 && (
              <button onClick={handlePrevSet} style={{ borderRadius: '3px', display: 'flex' }}>
                <ArrowBackIosNewIcon />
              </button>
            )}

            {Array.from({ length: endPage - startPage + 1 }, (_, i) => (
              <button
                key={startPage + i}
                onClick={() => paginate(startPage + i)}
                className={currentPage === startPage + i ? 'active' : ''}
              >
                {startPage + i}
              </button>
            ))}

            {endPage < totalPages && (
              <button onClick={handleNextSet} style={{ borderRadius: '3px', display: 'flex' }}>
                <ArrowForwardIosIcon />
              </button>
            )}
          </div>
        </div>
      </div>
      {addNewUser && (
        <AddUser
          onCancel={closeDialog}
          roleNames={roleNames}
        />
      )}
    </div>
  );
};

export default ManageRoles;
